import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFuncionGet = async (credentials, data) => {
  const body = {
    service: "RNHFuncionGet",
    params: {
      rnhFuncionId: data?.id || null,
      rnhFuncionNombre: data?.nombre || null,
      rnhFuncionCod: data?.cod || null,
      // Las funciones de UN agrupamiento. Va el ID, no el nombre: ojo que en la RESPONSE
      // el campo del mismo nombre trae el NOMBRE del agrupamiento, no su id.
      rnhFuncionAgrupamientoId: data?.agrupamientoId || null,
      page: data?.page ?? null,
      pageSize: data?.pageSize ?? null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
